module.exports = __webpack_public_path__ + "img/timer.1db6ef18.svg";